import React from "react";

export function BrandSmall() {
    return <div className="brand-small">
        <span className="blazing">blazing</span><span className="torch">torch</span>
    </div>
}